import { Address } from 'models/Address/address.model';
import { MultipleOrigins } from 'models/MultipleOrigins/multipleOrigins.model';
import { serializable, alias, object, list, primitive } from 'serializr';

export class MultipleOriginsProductRawMaterial {

    @serializable
    id?: number;
  
    @serializable(alias('activity_label', primitive()))
    activityLabel?: string;
  
    @serializable(alias('product_id', primitive()))
    productId?: number;
  
    @serializable
    quantity?: string;
  
    @serializable(alias('sub_origin', primitive()))
    subOrigin?: boolean;
  
    @serializable
    type?: string;
  
    @serializable(alias('unit', primitive()))
    unit?: string;
  
    @serializable(alias('multiple_origin', list(object(MultipleOrigins))))
    multipleOrigin?: MultipleOrigins[];
  
    @serializable
    co2e?: number;
  
    @serializable
    origin?: string;
  
    @serializable(object(Address))
    address?: Address;
  
    @serializable(alias('activity_mapping_region_spec_id', primitive()))
    activityMappingRegionSpecId?: number;
  
    @serializable(alias('origin_share', primitive()))
    originShare?: number;
  
    @serializable(alias('units_per_packaging_material', primitive()))
    unitsPerPackagingMaterial?: number;
  
    
  
  }